import { render, staticRenderFns } from "./CoapCommandDestinationUpdateDialog.vue?vue&type=template&id=2130d30a&"
import script from "./CoapCommandDestinationUpdateDialog.vue?vue&type=script&lang=ts&"
export * from "./CoapCommandDestinationUpdateDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports